// removed by extract-text-webpack-plugin
module.exports = {"container":"deactivate-prescription-form__container___2H6GP"};


//////////////////
// WEBPACK FOOTER
// ./study_coordinator/src/components/subjects/deactivate-prescription-form.css
// module id = 1207
// module chunks = 0